<canvas
  baseChart
  [type]="type"
  [data]="chartData"
  [options]="chartOptions"
  [width]="width"
  [height]="height">
</canvas>